'use strict';var _desc,_value,_class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const SessionExpiredError=require('../../../../dist-es6/client/services/errors/sessionExpiredError');
const{HandleUncaughtErrors:HandleUncaughtErrors}=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations;
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');
const LoginModalConfig=require('./modals/loginModalConfig');let

LoginController=(_class=function(_BaseController){_inherits(LoginController,_BaseController);
function LoginController($modal,$state,$window,$timeout,userService,uncaughtErrorHandler){_classCallCheck(this,LoginController);var _this=_possibleConstructorReturn(this,
_BaseController.call(this,uncaughtErrorHandler));

_this._$state=$state;
_this._$window=$window;
_this._$modal=$modal;
_this._$timeout=$timeout;
_this._userService=userService;

_this._destinationUrl=_this._getDestinationIfValid();
if(!_.exists(_this._destinationUrl)){
_this._$state.params.return_to=null;
}

_this._$timeout(function(){return _this._attemptToContinueOrGoToLogin()});return _this;
}LoginController.prototype.


_attemptToContinueOrGoToLogin=function(){var ref=_asyncToGenerator(function*(){var _this2=this;
yield this._tryRefreshCurrentUserState();

if(_.exists(this._userService.currentUser)){
this._continueFromLogin();
return;
}

this._loginModalInstance=this._$modal.open(LoginModalConfig);
this._loginModalInstance.result.then(function(){return _this2._continueFromLogin()});
});function _attemptToContinueOrGoToLogin(){return ref.apply(this,arguments)}return _attemptToContinueOrGoToLogin}();LoginController.prototype.


_tryRefreshCurrentUserState=function(){var ref=_asyncToGenerator(function*(){var _this3=this;
try{
yield this._userService.continueUserSession();
}catch(e){
if(e instanceof SessionExpiredError){
return this._$timeout(function(){return _this3._userService.clearAllUserData()});
}

if("production"==='development'){
console.error(e);
}


}
});function _tryRefreshCurrentUserState(){return ref.apply(this,arguments)}return _tryRefreshCurrentUserState}();LoginController.prototype.

_getDestinationIfValid=function _getDestinationIfValid(){
if(!_.exists(this._$state.params.return_to)){
return;
}

const destination=decodeURIComponent(this._$state.params.return_to);
const currentHost='https://'+this._$window.location.host;

if(!destination.startsWith(currentHost)||
destination.startsWith(currentHost+'/#/login')||
destination===currentHost+'/'){
return;
}

return destination;
};LoginController.prototype.

_continueFromLogin=function _continueFromLogin(){
if(_.exists(this._destinationUrl)){
this._$window.location=this._destinationUrl;
return;
}

this._$state.go("fdc.features.emiratesDashboard");
};return LoginController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'_attemptToContinueOrGoToLogin',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_attemptToContinueOrGoToLogin'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_tryRefreshCurrentUserState',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_tryRefreshCurrentUserState'),_class.prototype)),_class);


module.exports=LoginController;
//# sourceMappingURL=loginController.js.map
